angular.module('NumbersEditor')
    .factory('SportCodeFactory', [
        '$http', function ($http) {

            var urlBase = '/api/SportCode';
            var sportCodeFactory = {};

            sportCodeFactory.getAll = function () {
                return $http.get(urlBase);
            };

            sportCodeFactory.get = function (sportCode) {
                return $http.get(urlBase + "/" + sportCode);
            };

            sportCodeFactory.saveSportCode = function (sportCode) {
                return $http.post(urlBase + "/save", sportCode);
            };

            sportCodeFactory.deleteSportCode = function (sportCode) {
                return $http.delete(urlBase + "/" + sportCode);
            };

            return sportCodeFactory;
        }
    ]);